module.exports = __webpack_public_path__ + "static/media/13ITC4.525e8cdb.jpg";